import { useTranslation } from 'react-i18next'
import { ReactSVG } from 'react-svg'
import { useMediaQuery } from 'usehooks-ts'

import useCartComment from '@features/cart/hooks/useCartComment'
import { commentedPositionsSelector, useCartStore } from '@features/cart/model/useCartStore'

import { Product } from '@shared/generated'
import Button, { ButtonShapeVariant, type ButtonSizeVariant } from '@shared/ui/button'

import styles from './styles.module.scss'



interface CommentButtonProps {
  product: Product;
  size?: ButtonSizeVariant
  shape?: ButtonShapeVariant
}

export default function CommentButton (props: CommentButtonProps) {
  const { product } = props
  const { t: tca } = useTranslation('cart')
  const { t: tc } = useTranslation('common')
  const { openCartCommentModal } = useCartComment()

  const commentedPositions = useCartStore(commentedPositionsSelector)
  const isMobile = useMediaQuery('(max-width: 375px)')

  if (commentedPositions.includes(String(product.id))) {
    return (
      <Button
        theme="grey"
        className={isMobile ? styles.editButton : styles.button}
        onClick={() => openCartCommentModal(product)}
        size={props.size}
        shape={props.shape}
      >
        {isMobile && (
          <ReactSVG
            src="/icons/pencil.svg"
            wrapper="span"
            className={styles.icon}
          />
        )}
        {isMobile ? tc('wish.edit_short') : tc('wish.edit_full')}
      </Button>
    )
  }

  return (
    <Button
      theme="grey"
      className={styles.button}
      onClick={() => openCartCommentModal(product)}
      size={props.size}
      shape={props.shape}
    >
      {tca('preview.cart_wish')}
    </Button>
  )
}
